const initialState = 0;

function clampQuestionIndex(questionIndex, calculatorLength) {
  if (calculatorLength <= 0) {
    return 0;
  }

  return Math.max(0, Math.min(questionIndex, calculatorLength - 1));
}

function SetCalculatorQuestionIndex(state, action) {
  const calculatorLength = action.calculatorKeys.length;
  return clampQuestionIndex(action.questionIndex, calculatorLength);
}

function ShowNextQuestion(state, action) {
  const calculatorLength = action.calculatorKeys.length;
  return clampQuestionIndex(state + 1, calculatorLength);
}

function ShowPreviousQuestion(state, action) {
  const calculatorLength = action.calculatorKeys.length;
  return clampQuestionIndex(state - 1, calculatorLength);
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    return initialState;
  }
  switch (action.type) {
    case 'SET_CALCULATOR_QUESTION_INDEX':
      return SetCalculatorQuestionIndex(state, action);
    case 'SHOW_NEXT_QUESTION':
      return ShowNextQuestion(state, action);
    case 'SHOW_PREVIOUS_QUESTION':
      return ShowPreviousQuestion(state, action);
    default:
      return state;
  }
}
